<vs-dialog
  *vsLet="isMobile$ | async as isMobile"
  [config]="{ dialogContainerClass: 'w-[350px] sm:w-[500px] max-w-[600px]' }"
>
  <vs-dialog-header
    [config]="{
      mode: isMobile ? 'default' : 'simple',
      hideCloseButton: false,

      icon: 'package',
      iconTheme: 'primary',

      title: editing ? 'Update ' + _distributor?.name : 'Register New Distributor',
      subtitle: editing ? 'Update ' + _distributor?.name + '\'s name and contact information' : 'Enter the details of the distributor you would like to register to the dashboard.',

      showDivider: true
    }"
  ></vs-dialog-header>

  <form [formGroup]="form">
    <ws-distributor-details-form formControlName="distributorDetails"></ws-distributor-details-form>

    <div class="grid grid-cols-1 sm:grid-cols-2 gap-6 mt-6">
      <vs-form-field appearance="responsive" [config]="{ label: 'Main Contact' }">
        <input vsInput type="text" formControlName="mainContact" placeholder="Enter main contact" />
      </vs-form-field>

      <vs-form-field appearance="responsive" [config]="{ label: 'Website' }">
        <input vsInput type="text" formControlName="website" placeholder="Enter website" />
      </vs-form-field>
    </div>

    <div formGroupName="address" class="grid grid-cols-1 sm:grid-cols-2 gap-6 mt-6">
      <vs-form-field appearance="responsive" [config]="{ label: 'Address line 1 *' }">
        <input vsInput type="text" formControlName="line1" placeholder="Enter address line 1" />
      </vs-form-field>

      <vs-form-field appearance="responsive" [config]="{ label: 'Address line 2' }">
        <input vsInput type="text" formControlName="line2" placeholder="Enter address line 2" />
      </vs-form-field>

      <vs-form-field appearance="responsive" [config]="{ label: 'City *' }">
        <input vsInput type="text" formControlName="city" placeholder="Enter city" />
      </vs-form-field>

      <vs-form-field appearance="responsive" [config]="{ label: 'Country *' }">
        <input vsInput type="text" formControlName="country" placeholder="Enter country" />
      </vs-form-field>

      <vs-form-field appearance="responsive" [config]="{ label: 'State *' }">
        <input vsInput type="text" formControlName="state" placeholder="Enter state" />
      </vs-form-field>

      <vs-form-field appearance="responsive" [config]="{ label: 'ZIP *' }">
        <input vsInput type="text" formControlName="zip" placeholder="Enter ZIP" />
      </vs-form-field>
    </div>

    <div *ngIf="canManageAccountInfo" class="grid grid-cols-1 sm:grid-cols-2 gap-6 mt-6">
      <vs-form-field appearance="responsive" [config]="{ label: 'Agent/Referral Source' }">
        <input vsInput type="text" formControlName="referralSource" placeholder="Enter agent or referral source" />
      </vs-form-field>

      <vs-form-field appearance="responsive" [config]="{ label: 'ACH name on account' }">
        <input vsInput type="text" formControlName="achName" placeholder="Enter ACH name on account" />
      </vs-form-field>

      <vs-form-field appearance="responsive" [config]="{ label: 'Bank Name' }">
        <input vsInput type="text" formControlName="bankName" placeholder="Enter bank name" />
      </vs-form-field>

      <vs-form-field appearance="responsive" [config]="{ label: 'Type' }">
        <input vsInput type="text" formControlName="accountType" placeholder="Enter account type" />
      </vs-form-field>

      <vs-form-field appearance="responsive" [config]="{ label: 'Account' }">
        <input vsInput type="text" formControlName="accountNumber" placeholder="Enter account number" />
      </vs-form-field>

      <vs-form-field appearance="responsive" [config]="{ label: 'Routing' }">
        <input vsInput type="text" formControlName="routingNumber" placeholder="Enter routing number" />
      </vs-form-field>

      <vs-form-field class="sm:col-span-2" appearance="responsive" [config]="{ label: 'W9 Link' }">
        <input vsInput type="text" formControlName="w9Link" placeholder="Enter W9 link" />
      </vs-form-field>
    </div>

    <ng-container>
      <vs-form-field class="mt-6" appearance="responsive" [config]="{ label: 'Program' }">
        <input vsInput type="text" formControlName="programName" placeholder="Enter program" />
      </vs-form-field>

      <div class="mt-6">
        <p class="text-sm font-medium text-gray-700 mb-1">Logo</p>
        <div *ngIf="existingLogoUrl && !form.value.logoFile" class="flex items-center gap-3 mb-2">
          <img
            [src]="existingLogoUrl"
            alt="Current logo"
            class="h-10 max-w-[160px] object-contain rounded border p-1"
          />
          <button vs-button appearance="outline" size="xs" theme="danger" (click)="removeLogo()">Remove</button>
        </div>
        <vs-file-input
          formControlName="logoFile"
          [accept]="'.SVG,.PNG,.JPG,.JPEG,.GIF'"
          [moreInfo]="'SVG, PNG, JPG, or GIF (max 2MB)'"
          (change)="onLogoSelected()"
        ></vs-file-input>
      </div>
    </ng-container>

    <ng-container *ngIf="canManageTags">
      <vs-form-field class="mt-6" appearance="responsive" [config]="{ label: 'Tags' }">
        <input vsInput type="text" formControlName="tags" placeholder="tag1,tag2" />
      </vs-form-field>
    </ng-container>

    <div class="flex flex-col-reverse sm:flex-row sm:justify-end gap-3 pt-4">
      <button vs-button appearance="outline" class="w-full sm:w-auto" [disabled]="saving" (click)="closeDialog()">
        Cancel
      </button>

      <button
        vs-button
        theme="primary"
        class="w-full sm:w-auto"
        [disabled]="saving || form.invalid || (editing && !form.dirty)"
        (click)="submit()"
      >
        {{ editing ? 'Update' : 'Create' }}
      </button>
    </div>
  </form>
</vs-dialog>
